export const bookmarksMatching = (left, right) => left.uuid === right.uuid && left.arkId.arkName === right.arkId.arkName
